import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import  GoldCoin  from 'src/assets/images/icons8-gold-coin-48.png'
import { CurrencyFormatter, hasAdminOrEmployeeRoleHandler, hasFranchiseRoleHandler, hasFranchiseSubuserRoleHandler } from 'src/helpers/common_helpers';
import { getIncentivePoints } from 'src/store/profile/actions';
import { RootReducerState } from 'src/store/reducers';

const IncentivePoints = () => {
      const dispatch = useDispatch()
      const { incentivePoints } = useSelector(
        (state: RootReducerState) => state.profilesReducer
      );

        useEffect(() => {
          const getAuthUser:any = localStorage.getItem("authUser");
          if (getAuthUser) {
            const obj = JSON.parse(getAuthUser);
            const id = obj.uid;
            if(hasAdminOrEmployeeRoleHandler() || hasFranchiseRoleHandler() || hasFranchiseSubuserRoleHandler() && id){
              dispatch(getIncentivePoints(id))
            }
          }
        }, []);

  return (
    <div className='d-flex justify-content-center align-items-center me-2'>
            <div className='img-container-incentive'>
                <img src={GoldCoin} alt="" />
            </div>
            <div className='text-container'>
                <b>{incentivePoints?.totalRewardValue ? CurrencyFormatter({value:incentivePoints?.totalRewardValue}) :  CurrencyFormatter({value:0})}</b>
            </div>
    </div>
  )
}

export default IncentivePoints